// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import deviceCareImg from "src/assets/images/operating-manual/virtual-reality-device/device-care.png";

const DeviceCare = () => {
  const { t } = useTranslation("operating-manual");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography fontSize="16px" fontWeight={600}>
        {t("Replacing Controller Batteries")}
      </Typography>
      <Typography>
        {t(
          "Locate the small triangle on the controller handle. Press on this area while pushing down to slide the panel off, exposing the battery area. Remove the old batteries and replace them with 1.5V AA batteries."
        )}
      </Typography>

      <Typography fontSize="16px" fontWeight={600}>
        {t("Lens Care")}
      </Typography>

      <Grid container>
        <Grid item xs={12} sm={9}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              mx: "20px",
            }}
          >
            <Typography>
              •{" "}
              {t(
                "Avoid exposing the lenses to sunlight at all times as this can cause damage."
              )}
            </Typography>
            <Typography>
              •{" "}
              {t(
                "Use an optical lens microfiber cleaning cloth dipped in a bit of water to wipe clean the lenses. Do not use alcohol, this may damage the lenses."
              )}
            </Typography>
            <Typography>
              • {t("For best results, wipe the lens between use.")}
            </Typography>
            <Typography>
              •{" "}
              {t(
                "For best results, ensure there is no source of light behind the patient because it can create reflection on lenses."
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={deviceCareImg} width="100%" alt="device-care" />
          </Box>
        </Grid>
      </Grid>

      <Typography fontSize="16px" fontWeight={600}>
        {t("Face Cushion Care")}
      </Typography>
      <Typography>
        {t(
          "Use sterile wipes with an alcohol-based ingredient to gently wipe the surfaces that come in contact with skin. If the face cushion begins to show signs of wear, please contact RetinaLogik to inquire about options to replace the face cushion."
        )}
      </Typography>
    </Box>
  );
};

export default DeviceCare;
